import api from '../api'
export default {
    namespaced: true,
    state: {
        equipmentTypeList: [],
        equipmentTypeDetail: ''
    },
    mutations: {
        GET_EQUIPMENT_LIST(state, data) {
            data.forEach(item => {
                item.typeId = item.typeId + ''
            })
            state.equipmentTypeList = data
        },
        GET_EQUIPMENT_DETAIL(state, data) {
            state.equipmentTypeDetail = data
        }
    },
    actions: {
        GET_EQUIPMENT_LIST({ commit, dispatch }, params) {
            return api.equipmentTypeList({
                params: params
            }).then((res) => {
                commit('GET_EQUIPMENT_LIST', res.payload)
                return res
            }).catch((rej) => {
                window.myVue.$message.error(rej.message)
            })
        },
        GET_EQUIPMENT_DETAIL({ commit, dispatch }, config) {
            return api.equipmentTypeDetail(config).then((res) => {
                commit('GET_EQUIPMENT_DETAIL', res.payload)
                return res
            }).catch((rej) => {
                window.myVue.$message.error(rej.message)
            })
        },
        DELETE_EQUIPMENT({ commit, dispatch }, params) {
            return api.deleteEquipmentType({
                params: params
            }).then((res) => {
                return res
            }).catch((rej) => {
                window.myVue.$message.error(rej.message)
            })
        },
        ADD_EQUIPMENT({ commit, dispatch }, config) {
            return api.addEquipmentType(config).then((res) => {
                return res
            }).catch((rej) => {
                window.myVue.$message.error(rej.message)
            })
        },
        UPDATE_EQUIPMENT({ commit, dispatch }, config) {
            return api.updateEquipmentType(config).then((res) => {
                return res
            }).catch((rej) => {
                window.myVue.$message.error(rej.message)
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/views/equipmentTypeManage/store/index.js